import { auth } from "../providers/firebase";
import React from "react";
import "./Login.css"
import { toast } from "react-toastify";
import Logo from "../images/Logo.png"
import BackgroundImage from "../images/loginFondo.jpg"
import { Link } from "react-router-dom";

class Login extends React.Component {
  constructor() {
    super()
    this.state = {
      email: "",
      password: ""
    }
  }

  login(e) {
    e.preventDefault()
    auth.signInWithEmailAndPassword(this.state.email, this.state.password).then(() => window.location.href = "/").catch(err => {
      switch (err.code) {
        case "auth/invalid-email":
          toast.error("El formato del correo electrónico es incorrecto")
          break;
        case "auth/user-disabled":
          toast.error("La cuenta ha sido deshabilitada por el administrador")
          break;
        case "auth/user-not-found":
          toast.error("El usuario no existe")
          break;
        case "auth/wrong-password":
          toast.error("Contraseña incorrecta")
          break;
        default:
          toast.error("Error desconocido")
          break;
      }
    })
  }
  render() {
    return (
      <div style={{ backgroundImage: `url(${BackgroundImage})` }} className="backgroundDiv">
        <div className="overlay"></div>
        <form className="loginForm" onSubmit={e => this.login(e)}>
          <div><img src={Logo} className="loginLogo" alt="Logo" /></div>
          <input type="email" required value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} placeholder="Correo electrónico" />
          <input type="password" required minLength="6" value={this.state.password} onChange={(e) => this.setState({ password: e.target.value })} placeholder="Contraseña" />
          <button type="submit">Iniciar Sesión</button>
          <Link to="/cambiarPassword">
            <div style={{
                        backgroundColor: "rgb(255, 255, 255)",
                        color: "rgb(48, 50, 72)",
                        margin: "10px auto 0",
                        padding: "15px 40px 0 30px",
                        fontWeight: "normal",
                        textAlign: "right",
                        fontSize: "14px"
                  }}>¿Has olvidado tu contraseña?
            </div>
          </Link>
        </form>
      </div>
    )
  }
}

export default Login;
